export const PageHeader = ({ eyebrow, title, subtitle, actions, testid = "page-header" }) => (
  <div className="fade-up mb-8 flex flex-col gap-4 md:flex-row md:items-end md:justify-between" data-testid={testid}>
    <div className="min-w-0">
      {eyebrow && <div className="eyebrow">{eyebrow}</div>}
      <h1 className="mt-2 text-3xl font-semibold tracking-tight sm:text-4xl" data-testid="page-title">{title}</h1>
      {subtitle && <div className="mt-2 text-sm text-muted-foreground">{subtitle}</div>}
      <div className="gold-rule mt-4 w-24" />
    </div>
    {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
  </div>
);
